import React from 'react';
import { Text, View, Svg, Path } from '@react-pdf/renderer';
import { renderToStaticMarkup } from 'react-dom/server';
import ReactHtmlParser from 'react-html-parser';
import { QRCode } from "react-qrcode-logo";

const PdfWithQrCode = (props) => {
    console.log("props",props);
    const defaultOptions = {
        ecLevel: "M",
        enableCORS: false,
        size: 150,
        quietZone: 10,
        bgColor: "#FFFFFF",
        fgColor: "#000000",
        logoImage: "",
        logoWidth: 30,
        logoHeight: 30,
        logoOpacity: 1,
        qrStyle: "squares",
      };
    
    const options = { ...defaultOptions, ...props.options };

    const qrCodeComponent = (
        // <QRCode
        //     value={ssf_id}
        //     renderAs="svg"
        //     size={80}
        // />
        <QRCode value={props.url} {...options}  renderAs="svg"/>
    );

    const qrCodeComponentStaticMarkup = renderToStaticMarkup(qrCodeComponent);

    const parsedQrCodeSvg = parseQrCodeMarkup(qrCodeComponentStaticMarkup);
    if (! parsedQrCodeSvg) {
        return null;
    }

    return (
        <View>
            <Svg
                style={{ width: 50, height: 50 }}
                viewBox="0 0 29 29"
            >
                {parsedQrCodeSvg.props.children.filter(c => c.type === 'path').map((child, index) => (
                    <Path
                        key={index}
                        d={child.props.d}
                        fill={child.props.fill}
                    />
                ))}
            </Svg>
        </View>
    );
}

const parseQrCodeMarkup = (markup) => {
    let parsedQrCodeSvg = null;

    ReactHtmlParser(markup).forEach(el => {
        const { type } = el;
        if (type === 'svg') {
            parsedQrCodeSvg = el;
        }
    });

    return parsedQrCodeSvg;
};

export default PdfWithQrCode;